<template>
  <div
    v-if="activeInvestorReport"
    class="report-container page-padding"
    style="font-family: Arial, sans-serif; color: black"
  >
    <h2 style="color: #8cc63f; font-weight: 500; text-align: center">
      {{
        activeInvestorReport.plan.name +
        " Annual Report (" +
        activeInvestorReport.plan_report.year +
        ")"
      }}
    </h2>
    <!-- Section 1: Summary -->
    <section class="summary-section" style="margin-bottom: 30px">
      <md-card
        class="md-card-stats"
        style="background-color: white; border-radius: 15px; padding: 25px"
      >
        <h3 style="color: #8cc63f; font-weight: bold; margin-bottom: 10px">
          Summary
        </h3>
        <p style="font-size: 16px; line-height: 1.5; text-align: justify">
          {{ activeInvestorReport.plan_report.summary }}
        </p>
      </md-card>
    </section>

    <!-- Section 2: Inline Cards -->
    <section
      class="cards-section"
      style="
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 30px;
        padding: 0;
        justify-content: space-between;
      "
    >
      <div class="col-12 col-md-3 performance-divs" style="padding-left: 0">
        <md-card class="md-card-stats performance-cards">
          <h4>Annual ROI</h4>
          <h4 :class="getROIClass()" style="font-weight: bold">
            {{ fixNumberView(activeInvestorReport.plan_report.roi) }}%
          </h4>
        </md-card>
      </div>
      <div class="col-12 col-md-3 performance-divs">
        <md-card class="md-card-stats performance-cards">
          <h4>Gross Profit</h4>
          <h4 :class="getROIClass()" style="font-weight: bold">
            ${{
              fixNumberView(
                (activeInvestorReport.capital *
                  activeInvestorReport.plan_report.roi) /
                  100
              )
            }}
          </h4>
        </md-card>
      </div>

      <div class="col-12 col-md-3 performance-divs">
        <md-card class="md-card-stats performance-cards">
          <h4>Grade</h4>
          <h4 :class="getGradeClass()" style="font-weight: bold">
            {{ activeInvestorReport.plan_report.grade }}
          </h4>
        </md-card>
      </div>

      <div class="col-12 col-md-3 performance-divs" style="padding-right: 0">
        <md-card class="md-card-stats performance-cards">
          <h4>Risk Level</h4>
          <h4 :class="getRiskLevelClass()" style="font-weight: bold">
            {{ risk_level }}
          </h4>
        </md-card>
      </div>
    </section>

    <!-- Section 3: Table -->
    <section class="table-section" style="margin-bottom: 30px">
      <md-card
        class="md-card-stats"
        style="background-color: white; border-radius: 15px; padding: 25px"
      >
        <h3 style="color: #8cc63f; font-weight: bold">
          Yearly Transactions Overview
        </h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 15px">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd; padding: 8px">Description</th>
              <th style="border: 1px solid #ddd; padding: 8px">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in transactions" :key="index">
              <td style="border: 1px solid #ddd; padding: 8px">
                {{ item.description }}
              </td>
              <td style="border: 1px solid #ddd; padding: 8px">
                ${{ item.amount }}
              </td>
            </tr>
          </tbody>
        </table>
      </md-card>
    </section>

    <!-- Section 4: Other Plans Comparison -->
    <section
      class="comparison-section"
      style="margin-bottom: 30px; display: flex; flex-wrap: wrap"
    >
      <div class="col-12 col-md-6 bar-charts-padding" style="padding-left: 0">
        <md-card
          class="md-card-stats"
          style="background-color: white; border-radius: 15px; padding: 25px"
        >
          <h3 style="color: #8cc63f; font-weight: bold">
            Historical Performance - {{ this.activeInvestorReport.plan.name }}
          </h3>
          <bar-chart
            v-if="previousYears.labels.length > 0"
            style="height: 300px"
            :yMin="-100"
            :chart-data="previousYears"
          ></bar-chart>
        </md-card>
      </div>
      <div class="col-12 col-md-6 bar-charts-padding" style="padding-right: 0">
        <md-card
          class="md-card-stats"
          style="background-color: white; border-radius: 15px; padding: 25px"
        >
          <h3 style="color: #8cc63f; font-weight: bold">
            Other Plans Performance
          </h3>
          <bar-chart
            v-if="comparisonData.labels.length > 0"
            style="height: 300px"
            :yMin="-100"
            :chart-data="comparisonData"
          ></bar-chart>
        </md-card>
      </div>
    </section>

    <!-- Action Buttons -->
    <section
      v-if="!activeInvestorReport.consented"
      class="action-buttons"
      style="text-align: center; margin-top: 30px"
    >
      <button
        @click="toggleManagePlanModal"
        style="
          background-color: #918b82;
          color: white;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          margin-right: 10px;
          cursor: pointer;
        "
      >
        Manage Plan
      </button>
      <button
        @click="confirmReport"
        style="
          background-color: #8cc63f;
          color: white;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          width: 135px;
        "
      >
        Confirm
      </button>
    </section>
    <manage-plan-modal
      v-if="activeInvestorReport && netProfit"
      :active="showManagePlanModal"
      :activeInvestorReport="activeInvestorReport"
      :netProfit="netProfit"
      @saveRequest="handleSave"
      @closeRequest="toggleManagePlanModal()"
    />
  </div>
</template>
<script>
import ManagePlanModal from "./components/modals/manageInvestorPlanModal.vue";
import { BarChart } from "../../components/ChartJS";
import { mapState } from "vuex";
import InvestorsFilter from "../../filters/InvestorsFilter";
import InvestorReportsFilter from "../../filters/InvestorReportsFilter";
import sweetAlert from "sweetalert2";
import PlanReportsFilter from "../../filters/PlanReportsFilter";
import { getPlanReports } from "../../api/directapi";
import { EventBus } from "../../event-bus";

export default {
  components: {
    BarChart,
    ManagePlanModal,
  },
  data() {
    return {
      contractCode: null,
      contractID: null,
      year: null,
      showManagePlanModal: false,
      summary:
        "This year has been a remarkable success, outperforming the previous year across key metrics. Our ROI saw a significant boost, reflecting the strength of our strategic investments and disciplined management. Profits increased substantially, driven by timely market decisions and an optimized fee structure. The standout performance of the crypto plan, with a 60% ROI, highlights our ability to identify and capitalize on high-growth opportunities, while other plans also showed solid gains. Improved portfolio diversification and enhanced client communication further strengthened our position. Overall, this year’s results demonstrate clear progress and set a strong foundation for sustained growth in the years ahead.",
      roi: null,
      profit: null,
      netProfit: null,
      grade: "A+",
      risk_level: "Very High",
      transactions: [
        { description: "(+) Invested Capital", amount: null },
        { description: "(+) Annual Revenue ", amount: null },
        { description: "(-) Management Fees", amount: null },
        { description: "(-) Performance Fees", amount: null },
        { description: "Net Balance", amount: null },
      ],
      comparisonData: {
        labels: [],
        datasets: [
          {
            label: "ROI (%)",
            backgroundColor: ["#8cc63f", "#FFD700", "#C0C0C0", "#00AEEF"],
            data: [],
          },
        ],
      },
      previousYears: {
        labels: [],
        datasets: [
          {
            label: "ROI (%)",
            backgroundColor: ["#8cc63f", "#FFD700", "#C0C0C0", "#00AEEF"],
            data: [],
          },
        ],
      },
      previousPlanPerformances: [],
    };
  },
  created: function () {
    this.selectedInvestorId = this.$route.params.investorId;
    this.contractCode = this.$route.params.contractCode;
    this.contractID = this.$route.params.contractID;
    this.year = this.$route.params.year;
    this.scrollToTop();
    var investorsFilter = InvestorsFilter();
    investorsFilter.ids = [this.selectedInvestorId];
    this.$store
      .dispatch("searchInvestors", {
        filter: investorsFilter,
        resultMode: "default",
      })
      .then(() => {
        if (this.activeInvestor.id != this.selectedInvestorId) {
          this.$router.push(
            "/" +
              this.activeInvestor_type +
              "/investor/" +
              this.selectedInvestorId.code +
              "/" +
              this.selectedInvestorId.id
          );
        } else {
          var investorReportsFilter = new InvestorReportsFilter();
          investorReportsFilter.investor_ids = [this.activeInvestor.id];
          investorReportsFilter.contract_ids = [this.contractID];
          investorReportsFilter.years = [this.year];
          investorReportsFilter.with = ["contract", "planReport"];
          investorReportsFilter.appends = ["plan"];
          this.$store
            .dispatch("searchInvestorReports", {
              filter: investorReportsFilter,
              resultMode: "default",
            })
            .then(() => {
              if (!this.activeInvestorReport) {
                this.$router.push("/" + this.activeInvestor_type);
              }
              this.profit =
                (this.activeInvestorReport.capital *
                  this.activeInvestorReport.plan_report.roi) /
                100;
              let mgmtFees = this.activeInvestorReport.capital * 0.02;
              let performanceFees = 0;
              if (this.activeInvestorReport.plan_report.roi > 30) {
                performanceFees = this.profit * 0.25;
              } else if (this.activeInvestorReport.plan_report.roi > 20) {
                performanceFees = this.profit * 0.2;
              } else if (this.activeInvestorReport.plan_report.roi > 10) {
                performanceFees = this.profit * 0.1;
              } else if (this.activeInvestorReport.plan_report.roi > 0) {
                performanceFees = this.profit * 0.05;
              }
              if (this.activeInvestorReport.plan.id == 1) {
                this.risk_level = "Medium";
              } else if (this.activeInvestorReport.plan.id == 2) {
                this.risk_level = "Low";
              } else if (this.activeInvestorReport.plan.id == 3) {
                this.risk_level = "Very High";
              } else if (this.activeInvestorReport.plan.id == 4) {
                this.risk_level = "Medium";
              }

              this.netProfit = this.profit - mgmtFees - performanceFees;
              let net =
                this.activeInvestorReport.capital +
                this.profit -
                mgmtFees -
                performanceFees;

              this.transactions[0].amount = this.fixNumberView(
                this.activeInvestorReport.capital
              );
              this.transactions[1].amount = this.fixNumberView(this.profit);
              this.transactions[2].amount = this.fixNumberView(mgmtFees);
              this.transactions[3].amount = this.fixNumberView(performanceFees);
              this.transactions[4].amount = this.fixNumberView(net);

              var planReportsFilter = new PlanReportsFilter();
              planReportsFilter.plan_ids = [this.activeInvestorReport.plan.id];
              planReportsFilter.orderBy = ["year", "asc"];
              getPlanReports(planReportsFilter).then((response) => {
                let years = [];
                let data = [];
                this.previousPlanPerformances =
                  response.body.results.planReports;
                this.previousPlanPerformances.forEach((planReport) => {
                  years.push(planReport.year);
                  data.push(planReport.roi);
                });
                this.previousYears.labels = years;
                this.previousYears.datasets[0].data = data;
              });
            });
          var planReportsFilter = new PlanReportsFilter();
          planReportsFilter.years = [this.year];
          planReportsFilter.appends = ["planDetails"];
          this.$store
            .dispatch("searchPlanReports", {
              filter: planReportsFilter,
              resultMode: "default",
            })
            .then(() => {
              let labels = [];
              let data = [];
              this.planReports.forEach((planReport) => {
                // labels.push(planReport.planDetails.code + " (" + planReport.planDetails.name + ")");
                labels.push(planReport.planDetails.name);
                data.push(planReport.roi.toFixed(2));
              });
              this.comparisonData.datasets[0].data = data;
              this.comparisonData.labels = labels;
            });
        }
      });

    let self = this;
    EventBus.$on("changeTab", function (tab) {
      if (tab == "dashboard") {
        self.$router.push("/" + self.activeInvestor_type + "/dashboard");
      }
    });

    // var contractsFilter = InvestorContractsFilter();
    // contractsFilter.codes = [this.contractCode];
    // contractsFilter.with = ["plan"];
    // this.$store
    //   .dispatch("searchInvestorContracts", {
    //     filter: contractsFilter,
    //     resultMode: "default",
    //   })
    //   .then(() => {
    //     this.$store.dispatch("searchPlansPerformance", {}).then(() => {
    //       this.activePlanPerformance = this.plansPerformance.find(
    //         (planPerformance) =>
    //           planPerformance.plan_id === this.activeContract.plan.id
    //       ).performance;
    //       let labels = [];
    //       let data = [];
    //       this.plansPerformance.forEach((planPerformance) => {
    //         labels.push(planPerformance.plan_name);
    //         data.push(planPerformance.performance.toFixed(2));
    //       });
    //       this.comparisonData.datasets[0].data = data;
    //       this.comparisonData.labels = labels;
    //       if (this.activePlanPerformance > 35) {
    //         this.grade = "A+";
    //       } else if (this.activePlanPerformance >= 18) {
    //         this.grade = "A";
    //       } else if (this.activePlanPerformance > 15) {
    //         this.grade = "B+";
    //       } else if (this.activePlanPerformance > 12) {
    //         this.grade = "B";
    //       } else if (this.activePlanPerformance > 8) {
    //         this.grade = "C+";
    //       } else if (this.activePlanPerformance > 5) {
    //         this.grade = "C";
    //       } else if (this.activePlanPerformance > 0) {
    //         this.grade = "D";
    //       } else if (this.activePlanPerformance < 0) {
    //         this.grade = "F";
    //       }
    //   });
    // });
  },
  computed: {
    ...mapState({
      activeInvestor: (state) =>
        state.investorStore.investorSearch.investors[0],
      activeContract: (state) =>
        state.contractStore.investorContractSearch.investorContracts[0],
      activeInvestorReport: (state) =>
        state.investorReportStore.investorReportSearch.investorReports[0],
      plansPerformance: (state) =>
        state.planStore.planPerformanceSearch.plansPerformance,
      planReports: (state) =>
        state.planReportStore.planReportSearch.planReports,
      authUser: (state) => state.userStore.authUser,
      createTransactionRequestStatus: (state) =>
        state.transactionRequestStore.transactionRequestCreate
          .createTransactionRequestStatus,
      updateInvestorReportStatus: (state) =>
        state.investorReportStore.investorReportUpdate
          .updateInvestorReportStatus,
    }),
  },
  methods: {
    handleTopUp() {
      alert("Top-Up process initiated.");
    },
    scrollToTop() {
      const modalContent = document.querySelector(".md-theme-default");
      modalContent.scrollTo(0, 0);
    },
    handleWithdraw() {
      alert("Withdraw process initiated.");
    },
    handleSave(transactionRequestStorer) {
      sweetAlert({
        title: "Warning",
        text: "Managing plan is resitricted to investors",
        type: "warning",
        confirmButtonText: "Done",
      });
      // this.$store.dispatch(
      //   "createTransactionRequest",
      //   transactionRequestStorer
      // );
      // this.$store.dispatch("confirmInvestorReport", {
      //   id: this.activeInvestorReport.id,
      //   consented: true,
      // });
    },

    toggleManagePlanModal() {
      this.showManagePlanModal = !this.showManagePlanModal;
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    getRiskLevelClass() {
      if (this.risk_level == "Very High" || this.risk_level == "High") {
        return "high-risk-lev";
      } else if (this.risk_level == "Medium") {
        return "medium-risk-lev";
      } else if (this.risk_level == "Low") {
        return "low-risk-lev";
      }
    },
     getROIClass() {
      if (this.activeInvestorReport.plan_report.roi >= 0) {
        return "high-grade";
      } else {
        return "low-grade";
      }
    },
    getGradeClass() {
      if (
        ["A+", "A", "B+"].includes(this.activeInvestorReport.plan_report.grade)
      ) {
        return "high-grade";
      } else if (
        ["B", "C+", "C"].includes(this.activeInvestorReport.plan_report.grade)
      ) {
        return "medium-grade";
      } else if (
        ["D", "F"].includes(this.activeInvestorReport.plan_report.grade)
      ) {
        return "low-grade";
      }
    },
    confirmReport() {
      sweetAlert({
        title: "Are you sure?",
        text:
          "Please sign with your full name to confirm plan changes (" +
          this.activeInvestor.first_name +
          " " +
          this.activeInvestor.last_name +
          ")",
        input: "text",
        inputPlaceholder: "Enter your full name here",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.dismiss == "cancel") {
          return;
        }
        /* Read more about isConfirmed, isDenied below */
        if (
          result.value ===
          this.activeInvestor.first_name + " " + this.activeInvestor.last_name
        ) {
          sweetAlert({
            title: "Warning",
            text: "Confirming plan is resitricted to investors",
            type: "warning",
            confirmButtonText: "Done",
          });
          // this.$store.dispatch("confirmInvestorReport", {
          //   id: this.activeInvestorReport.id,
          //   consented: true,
          // });
        } else {
          sweetAlert({
            title: "Error",
            text: "Your signature does not match",
            type: "error",
            confirmButtonText: "Return",
            confirmButtonColor: "#d73535",
          });
        }
      });
    },
  },
  watch: {
    createTransactionRequestStatus() {
      if (this.createTransactionRequestStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Transaction request has been sent successfully",
          type: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.activeInvestor_type);
        });
      } else if (this.createTransactionRequestStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Transaction request has failed",
          type: "error",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateInvestorReportStatus() {
      if (this.updateInvestorReportStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Report has been confirmed successfully",
          type: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.activeInvestor_type);
        });
      } else if (this.updateInvestorReportStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Report confirmation has failed",
          type: "error",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style scoped>
table th,
table td {
  text-align: left;
}
button:hover {
  opacity: 0.9;
}
.performance-cards {
  background-color: white;
  border-radius: 15px;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  max-width: 350px;
}
.page-padding {
  padding: 20px 50px;
}
.high-risk-lev {
  color: #ee4444;
}
.medium-risk-lev {
  color: #f19e2d;
}
.low-risk-lev {
  color: #bed663;
}
.high-grade {
  color: #8cc63f;
}
.medium-grade {
  color: #f19e2d;
}
.low-grade {
  color: #ee4444;
}
@media (max-width: 767px) {
  .page-padding {
    padding: 20px 25px;
  }
  .bar-charts-padding {
    padding: 0;
  }
  .performance-divs {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/admin/investorReport.vue